import { useDispatch } from 'react-redux';
import { toggleMobileFiltersModal } from 'shared/slices';

export function useMobileFilters() {
  const dispatch = useDispatch();

  const openMobileFiltersModal = () => dispatch(toggleMobileFiltersModal(true));
  const closeMobileFiltersModal = () => dispatch(toggleMobileFiltersModal(false));

  return {
    openMobileFiltersModal,
    closeMobileFiltersModal,
  };
}
